<template>
  <div>
    <van-nav-bar
        v-if="!$inApp"
        title=""
        left-text="返回"
        right-text="联系客服"
        left-arrow
        @click-left="backLastPage"
        @click-right="goToHelpPage"
    />
    <van-loading v-if="isLoading" type="spinner" size="24px" style="text-align: center; padding: 20px;">加载中...</van-loading>
    <van-empty v-else-if="showOrderNotFoundEmpty" description="订单不存在或已失效" />
    <template v-if="!showOrderNotFoundEmpty">
      <div class="fui-page__hd">
        <div class="fui-page__title">
          <template v-if="isViewingHistory">
            <span class="history-tag">订单号码</span>
            {{ currentOrderNo }}
          </template>
          <template v-else>
            <img v-if="game && gameIcon(game)" :src="gameIcon(game)" alt="" class="game-title-icon" @error="hideIcon($event)">
            {{ game ? game.name + ' 战区修改' : '电竞助手战区修改' }}
          </template>
        </div>
        <div class="fui-page__desc">
          如果您在使用的过程中遇到任何问题，请点击右上角"联系客服"获取帮助
        </div>
      </div>
      <war-step :step-num="stepNum"/>
      <div v-if="stepNum === 1" class="">
        <!-- 服务类型(修改方式)已在游戏选择页选定,由路由 query.modifyType 透传,这里不再展示 -->
        <div class="fui-section__title">请选择系统</div>
        <van-radio-group v-model.number="gameOs" checked-color="#465CFF">
          <van-cell-group>
            <van-cell title="苹果微信(需要两个设备扫码)" clickable @click="gameOs = '3'">
              <template #right-icon>
                <van-radio name="3"/>
              </template>
            </van-cell>
            <van-cell title="安卓微信(需要两个设备扫码)" clickable @click="gameOs = '1'">
              <template #right-icon>
                <van-radio name="1"/>
              </template>
            </van-cell>
            <van-cell title="苹果QQ" clickable @click="gameOs = '2'">
              <template #right-icon>
                <van-radio name="2"/>
              </template>
            </van-cell>
            <van-cell title="安卓QQ" clickable @click="gameOs = '0'">
              <template #right-icon>
                <van-radio name="0"/>
              </template>
            </van-cell>
          </van-cell-group>
        </van-radio-group>
        <div class="nextBtn">
          <van-button color="#465CFF" type="info" block @click="selectOsArea">下一步</van-button>
        </div>
      </div>
      <div v-if="stepNum === 2" class="">
        <div class="fui-section__title">请选择地区</div>
        <van-field
            v-model="fieldValue"
            is-link
            readonly
            label="地区"
            placeholder="请选择目标战区"
            @click="show = true"
        />
        <van-popup v-model="show" closeable round position="bottom">
          <div class="van-cascader__header" style="margin-top: 3px">
            <h2 class="van-cascader__title">请选择目标战区</h2>
          </div>
          <form action="/">
            <van-search
                v-model="searchKey"
                placeholder="请输入地区名称"
                @search="onSearch"
                @cancel="onCancel"
                @input="onSearchInput"
            />
          </form>
          <van-cascader v-if="showCascaderList"
                        v-model="cascaderSelectedId"
                        :show-header=false
                        :options="options"
                        @close="show = false"
                        @finish="onFinish"
                        @change="onChange"
                        :closeable=false
                        :field-names="fieldNames"
          >
            <template slot="option" slot-scope="scope">
              <div class="option_name" :class="{ optdisabled: scope.option.disabled }">
                <span>{{ scope.option.short_name }}</span>
              </div>
            </template>
          </van-cascader>
          <van-empty v-if="!showCascaderList && searchResult.length === 0" image="search" description="没有搜索到该地区"/>
          <div class="search-container" v-if="!showCascaderList && searchResult.length !== 0">
            <div data-v-4edb6a76="" class="van-cascader">
              <div class="van-tabs van-tabs--line van-cascader__tabs">
                <div class="van-tabs__wrap van-tabs__wrap--scrollable">
                  <div role="tablist" class="van-tabs__nav van-tabs__nav--line van-tabs__nav--complete">
                    <div role="tab" aria-selected="true"
                         class="van-tab van-tab--active van-cascader__tab van-cascader__tab--unselected"><span
                        class="van-tab__text">请选择</span></div>
                    <div class="van-tabs__line" style="transform: translateX(37px) translateX(-50%);"></div>
                  </div>
                </div>
                <div class="van-tabs__content van-tabs__content--animated">
                  <div class="van-tabs__track" style="transform: translate3d(0%, 0px, 0px); transition-duration: 0.3s;">
                    <div role="tabpanel" class="van-tab__pane-wrapper">
                      <div class="van-tab__pane">
                        <ul class="van-cascader__options">
                          <li @click="clickResultItem(item)" 
                              class="van-cascader__option"
                              :class="{'van-cascader__option--disabled': item.disabled}" 
                              v-for="item in searchResult"
                              :key="item.id">
                            <span>{{ item.displayFullName }}</span>
                            <i class="van-icon van-icon-arrow van-cell__right-icon"></i>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </van-popup>
        <div class="nextBtn">
          <van-button color="#465CFF" type="info" block @click="viewOrderInfo">下一步</van-button>
          <van-button class="van-button-back" color="transparent" type="info" block @click="backStep(1)">上一步
          </van-button>
        </div>
      </div>
      <div v-if="stepNum === 3" class="">
        <template v-if="game">
          <div class="fui-section__title">选择的游戏</div>
          <div class="fui-text__wrap fui-text__block fui-text__left" style="text-align: left; padding-left: 25px;">
            <div class="fui-text__content fui-text__black" userselect="false"
                 style="font-size: 15px; text-align: left; text-decoration: none; font-weight: 400;">
              <span>{{ game.name }}<template v-if="selectedModifyTypeLabel"> · {{ selectedModifyTypeLabel }}</template></span>
            </div>
          </div>
          <div style="margin-top: 30px"></div>
        </template>
        <div class="fui-section__title">选择的系统</div>
        <div class="fui-text__wrap fui-text__block fui-text__left" style="text-align: left; padding-left: 25px;">
          <div class="fui-text__content fui-text__black" userselect="false"
               style="font-size: 15px; text-align: left; text-decoration: none; font-weight: 400;">
            <span>{{ selectedOSArea }}</span>
          </div>
        </div>
        <div style="margin-top: 30px"></div>
        <div class="fui-section__title">选择的战区</div>
        <div class="fui-text__wrap fui-text__block fui-text__left" style="text-align: left; padding-left: 25px;">
          <div class="fui-text__content fui-text__black" userselect="false"
               style="font-size: 15px; text-align: left; text-decoration: none; font-weight: 400;">
            <span>{{ fieldValue }}</span>
          </div>
        </div>
        <div class="nextBtn">
          <van-button color="#465CFF" type="info" block @click="submitOrderInfo" :loading="submitButtonLoading"
                      loading-text="正在提交" :disabled="submitButtonStatus">
            {{ submitButtonText }}
          </van-button>
          <van-button class="van-button-back" color="transparent" type="info" block @click="backStep(2)">上一步
          </van-button>
        </div>
      </div>
      <van-popup v-model="showPay" closeable round position="bottom">
        <div class="van-cascader__header" style="margin-top: 3px">
          <h2 class="van-cascader__title">请选择支付方式</h2>
        </div>
        <div class="pay">
          <div class="pay-wrap">
            <div v-for="payType in payTypes" :key="payType.code" class="pay-type"
                 :class="{'active': selectedPayCode === payType.code}"
                 @click="selectedPayCode = payType.code">
              <img v-if="payTypeIcon(payType)" :src="payTypeIcon(payType)" alt="">
              <div>{{ payType.name }}<sup v-if="payType.discount > 0">优惠</sup></div>
              <img :src="payCheckIcon" alt="" class="check">
            </div>
            <div v-if="payTypes.length === 0" class="pay-empty">暂无可用支付方式,请稍后再试</div>
          </div>
        </div>
        <van-submit-bar :loading="submitOrderButtonLoading" :price="goodsPrice" button-text="提交订单" @submit="onPay">
          <template #tip>
            支付后请注意及时保存战区修改链接, <span @click="showUseGuide" style="color: #1989fa;">使用说明</span>
          </template>
        </van-submit-bar>
      </van-popup>
    </template>
  </div>
</template>

<script>
import WarStep from "@/components/WarStep";
import {loadGames, findGame, gameIcon} from "@/utils/games";
import {addOrder, removeOrder} from "@/utils/orderCache";
import payWxIcon from "@/assets/icons/pay-wx.png";
import payAlipayIcon from "@/assets/icons/pay-alipay.png";
import payCheckIcon from "@/assets/icons/pay-check.png";
import {
  Button,
  Cell,
  CellGroup,
  Dialog,
  Field,
  Popup,
  Radio,
  RadioGroup,
  Toast,
  SubmitBar,
  NavBar,
  ImagePreview,
  Empty as VanEmpty,
  Loading as VanLoading
} from "vant";

// 支付方式图标优先用后端 t_app_pay_type.icon(base64, 同 /svip 页 th:src),缺失时按 alias 兜底本地切图
const PAY_TYPE_ICONS = {
  wx: payWxIcon,
  alipay: payAlipayIcon
};

export default {
  name: "WarOrder",
  components: {
    WarStep,
    VanRadioGroup: RadioGroup,
    VanCellGroup: CellGroup,
    VanCell: Cell,
    VanRadio: Radio,
    VanButton: Button,
    VanField: Field,
    VanPopup: Popup,
    VanSubmitBar: SubmitBar,
    ImagePreview,
    VanNavBar: NavBar,
    VanEmpty,
    VanLoading
  },
  props: {
    orderNo: {
      type: String,
      default: ''
    }
  },
  computed: {
    gameId() {
      //游戏配置未就绪时返回 null,调用方必须显式跳过请求。
      //严禁兜底成 0(王者荣耀): 各游戏战区数据独立且 externalId 不同,
      //拉错游戏的数据页面看不出异常(都是省市区),但下单会用错 addrId 改错战区。
      return this.game ? this.game.gameId : null;
    },
    selectedModifyTypeLabel() {
      if (!this.game || this.modifyType === null || this.modifyType === undefined) {
        return '';
      }
      const mt = (this.game.modifyTypes || []).find(t => t.value === this.modifyType);
      return mt ? mt.label : '';
    }
  },
  data() {
    return {
      // 游戏配置(来自 /api/game/war/games),多游戏差异全部由配置驱动
      games: [],
      game: null,
      modifyType: null,
      stepNum: 1,
      gameOs: '3',
      selectedOSArea: '',
      show: false,
      showCascaderList: true,
      fieldValue: '',
      location: '',
      cascaderValue: '',
      // 省市区级联数据，改为从后端接口异步加载
      options: [],
      // van-cascader 当前选中的节点 id
      cascaderSelectedId: null,
      searchResult: [],
      fieldNames: {
        text: 'short_name',
        value: 'id',
        children: 'children',
      },
      searchKey: '',
      submitButtonStatus: false,
      submitButtonText: '',
      submitButtonLoading: false,
      showPay: false,
      payTypes: [],
      selectedPayCode: '',
      payCheckIcon,
      goodsPrice: 0,
      goodsId: null,
      goodsAvailable: false,
      submitOrderButtonLoading: false,
      lastOrderNo: '',
      isViewingHistory: false,
      currentOrderNo: '',
      showOrderNotFoundEmpty: false,
      isLoading: false,
    }
  },
  watch: {
    '$route'(to, from) {
      console.log('Route changed:', to.params);
      if (to.params.orderNo !== from.params.orderNo) {
        console.log('OrderNo changed in route, new value:', to.params.orderNo);
        this.resetState();
        this.checkLastOrder();
      }
    },
    orderNo(newVal, oldVal) {
      console.log('Props orderNo changed:', newVal);
      if (newVal !== oldVal) {
        this.resetState();
        this.checkLastOrder();
      }
    }
  },
  methods: {
    gameIcon,
    hideIcon(e) {
      e.target.style.display = 'none';
    },
    /**
     * 应用游戏配置:设置修改方式(优先取路由透传,否则默认第一项)并重新加载该游戏的战区数据
     */
    applyGame(game) {
      if (!game || (this.game && this.game.gameId === game.gameId)) {
        return;
      }
      this.game = game;
      const types = game.modifyTypes || [];
      const queryType = parseInt(this.$route.query.modifyType, 10);
      if (!isNaN(queryType) && types.some(t => t.value === queryType)) {
        this.modifyType = queryType;
      } else {
        this.modifyType = types.length > 0 ? types[0].value : null;
      }
      // 切换游戏后战区数据和商品按游戏重新加载
      this.options = [];
      this.fieldValue = '';
      this.cascaderValue = '';
      this.loadProvinces();
      this.onloadGoodsInfo();
    },
    // 从后端加载省份列表（level = 1）
    loadProvinces() {
      if (this.gameId === null) {
        console.warn('游戏配置未就绪,跳过省份加载');
        return;
      }
      this.$axios.get('/api/game/war/district/list', {
        params: { level: 1, gameId: this.gameId }
      }).then((response) => {
        if (response.data && response.data.code === '0000') {
          const list = response.data.data || [];
          this.options = list.map(item => this.transformAddressToOption(item, 1, null));
        } else {
          Toast(response.data.desc || '省份数据加载失败');
        }
      }).catch(() => {
        Toast('省份数据加载失败');
      });
    },
    // 根据选中的省份加载城市列表（level = 2）
    loadCities(provinceOption) {
      if (!provinceOption || provinceOption.level !== 1 || this.gameId === null) {
        return;
      }
      // 已经加载过则不再重复拉取
      if (provinceOption.children && provinceOption.children.length > 0) {
        return;
      }
      this.$axios.get('/api/game/war/district/list', {
        params: { level: 2, parentId: provinceOption.id, gameId: this.gameId }
      }).then((response) => {
        if (response.data && response.data.code === '0000') {
          const list = response.data.data || [];
          // 将城市挂在对应省份下面
          provinceOption.children = list.map(item => this.transformAddressToOption(item, 2, provinceOption));
        } else {
          Toast(response.data.desc || '城市数据加载失败');
        }
      }).catch(() => {
        Toast('城市数据加载失败');
      });
    },
    // 根据选中的城市加载区县列表（level = 3）
    loadCounties(cityOption) {
      if (!cityOption || cityOption.level !== 2 || this.gameId === null) {
        return;
      }
      if (cityOption.children && cityOption.children.length > 0) {
        return;
      }
      this.$axios.get('/api/game/war/district/list', {
        params: { level: 3, parentId: cityOption.id, gameId: this.gameId }
      }).then((response) => {
        if (response.data && response.data.code === '0000') {
          const list = response.data.data || [];
          // 区县是第三级，不再挂 children，让级联在这里结束
          cityOption.children = list.map(item => this.transformAddressToOption(item, 3, cityOption));
        } else {
          Toast(response.data.desc || '区县数据加载失败');
        }
      }).catch(() => {
        Toast('区县数据加载失败');
      });
    },
    /**
     * 将后端返回的 WarAddressDO 转成前端级联组件需要的节点结构
     * 不同 level 使用不同的名称字段：
     * 1-省：province；2-市：city；3-区县：county
     */
    transformAddressToOption(address, level, parentOption) {
      let name = '';
      if (level === 1) {
        name = address.province;
      } else if (level === 2) {
        name = address.city;
      } else if (level === 3) {
        name = address.county;
      }
      const option = {
        id: address.id,
        short_name: name,
        level: level,
        parentId: address.parentId,
        // 提交时需要经纬度信息
        lng: address.areaLng,
        lat: address.areaLat
      };
      // 组装完整路径：省/市/区县
      if (parentOption && parentOption.level_path) {
        option.level_path = parentOption.level_path + '/' + name;
      } else {
        option.level_path = name;
      }
      // 前两级始终认为有下级，便于点击后再异步加载
      if (level === 1 || level === 2) {
        option.children = [];
      }
      return option;
    },
    /**
     * 当通过搜索结果选择地区时，为了让再次打开弹窗时能正确展示当前选择，
     * 需要在级联的 options 中构造一条包含该区县的路径，并同步 v-model 值。
     * 这里构造一棵“虚拟”的省/市/区县树，放在 options 的最前面，不影响真实的省市区数据。
     */
    updateCascaderForSearchSelection(item) {
      if (!item || !item.level_path) {
        return;
      }
      const parts = item.level_path.split('/');
      const provinceName = parts[0] || '';
      const cityName = parts[1] || '';
      const countyName = parts[2] || '';

      // 移除之前的搜索虚拟节点（如果存在）
      const REAL_OPTIONS = this.options.filter(opt => !opt.isSearchStub);

      // 构造一条仅包含当前选择的虚拟路径：省 -> 市 -> 区县
      const searchProvince = {
        id: '__search_province__',
        short_name: provinceName,
        level: 1,
        level_path: provinceName,
        isSearchStub: true,
        children: []
      };
      const searchCity = {
        id: '__search_city__',
        short_name: cityName,
        level: 2,
        level_path: provinceName && cityName ? (provinceName + '/' + cityName) : cityName,
        parentId: searchProvince.id,
        isSearchStub: true,
        children: []
      };
      const searchCounty = {
        id: item.id,
        short_name: countyName || item.displayFullName || parts.join(' '),
        level: 3,
        level_path: item.level_path,
        parentId: searchCity.id,
        lng: item.lng,
        lat: item.lat,
        isSearchStub: true
      };
      searchCity.children.push(searchCounty);
      searchProvince.children.push(searchCity);

      // 将虚拟路径插入到 options 最前面
      this.options = [searchProvince].concat(REAL_OPTIONS);
    },
    selectOsArea: function () {
      let date = new Date();
      let week = date.getDay();
      // 微信区扫码限制由后端配置驱动: wxMondayOnly=是否受限,
      // wxScanDay=可扫码星期(1=周一..7=周日), wxScanWindow=当天可扫时间窗(HH:mm-HH:mm)
      // 王者系 周一01:30-23:59, 无畏契约 周一10:00-23:59; 未下发配置时回退王者规则
      const wxLimited = !this.game || this.game.wxMondayOnly;
      if (wxLimited && (this.gameOs === '1' || this.gameOs === '3')) {
        const scanDay = (this.game && this.game.wxScanDay) || 1;
        const windowStr = (this.game && this.game.wxScanWindow) || '01:30-23:59';
        const parts = windowStr.split('-');
        const toMinutes = (s) => {
          const hm = s.split(':');
          return parseInt(hm[0], 10) * 60 + parseInt(hm[1], 10);
        };
        const dayLabels = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];
        const jsDay = scanDay % 7; // 配置1-7(周一..周日) -> JS getDay() 0-6(周日..周六)
        const nowMinutes = date.getHours() * 60 + date.getMinutes();
        if (week !== jsDay || nowMinutes < toMinutes(parts[0]) || nowMinutes > toMinutes(parts[1])) {
          Dialog.setDefaultOptions({
            confirmButtonText: '我知道了'
          })
          Dialog.alert({
            title: '系统提示',
            message: `微信区请在${dayLabels[jsDay]} ${parts[0]}-${parts[1]} 之间扫码修改`,
            theme: 'round-button',
          }).then(() => {
            // on close
          });
          return;
        }
      }
      // 未支付也允许先选择系统和战区,支付延后到"确认修改"时
      if (!window.orderNo && !this.goodsAvailable) {
        Toast('该游戏暂未开放购买，请联系客服');
        return;
      }
      this.stepNum = 2;
      const osArray = ['安卓QQ', '安卓微信', '苹果QQ', '苹果微信'];
      this.selectedOSArea = osArray[parseInt(this.gameOs)];
    },
    viewOrderInfo() {
      if (!this.cascaderValue || this.cascaderValue === '') {
        Toast('请选择要修改的战区');
      } else {
        this.stepNum = 3
        this.submitButtonStatus = true
        this.submitButtonText = '确认修改(3)'
        let timeLimit = 3
        let timerFlag = window.setInterval(() => {
          timeLimit--
          if (timeLimit <= 0) {
            this.submitButtonText = '确认修改'
            this.submitButtonStatus = false
            window.clearInterval(timerFlag)
          } else {
            this.submitButtonText = '确认修改(' + timeLimit + ')'
          }
        }, 1000)
      }
    },
    submitOrderInfo() {
      const orderNo = window.orderNo || this.currentOrderNo;
      if (!orderNo) {
        // 尚未支付:先保存当前选择,弹出支付,支付完成回跳后自动提交
        if (!this.goodsAvailable) {
          Toast('该游戏暂未开放购买，请联系客服');
          return;
        }
        this.showPay = true;
        return;
      }
      this.doSubmitOrder(orderNo, {
        gameArea: this.gameOs,
        levelPath: this.fieldValue,
        location: this.location,
        addrId: this.cascaderValue
      });
    },
    doSubmitOrder(orderNo, selection) {
      const submitGameId = selection.gameId !== undefined && selection.gameId !== null
          ? selection.gameId : this.gameId;
      //宁可报错也不能带着错误的游戏提交:addrId 属于特定游戏,用错游戏会改到别的战区
      if (submitGameId === null || submitGameId === undefined) {
        Toast('游戏配置加载失败,请刷新页面重试');
        return;
      }
      this.submitButtonLoading = true
      this.$axios.post('/api/game/war/submit', {
        orderNo: orderNo,
        gameArea: selection.gameArea,
        levelPath: selection.levelPath,
        location: selection.location,
        gameId: submitGameId,
        modifyType: selection.modifyType !== undefined ? selection.modifyType : this.modifyType,
        addrId: selection.addrId,
        output: 'json'
      }).then((response) => {
        if ('0000' === response.data.code) {
          this.clearPendingSubmit();
          this.isViewingHistory = true;
          this.currentOrderNo = orderNo;
          window.location.replace('/warzone/' + orderNo);
          Toast.success('提交成功');
          this.submitButtonLoading = false;
          this.submitButtonStatus = true;
          this.submitButtonText = '订单已提交';
        } else {
          Toast(response.data.desc)
          this.submitButtonLoading = false
        }
      }).catch(() => {
        Toast('提交失败，请稍后重试');
        this.submitButtonLoading = false;
      });
    },
    savePendingSubmit(orderNo) {
      try {
        localStorage.setItem('pendingWarSubmit', JSON.stringify({
          orderNo: orderNo,
          gameArea: this.gameOs,
          levelPath: this.fieldValue,
          location: this.location,
          addrId: this.cascaderValue,
          selectedOSArea: this.selectedOSArea,
          gameId: this.gameId,
          modifyType: this.modifyType
        }));
      } catch (e) { /* 存储失败时用户支付后需手动重选 */ }
    },
    getPendingSubmit(orderNo) {
      try {
        const raw = localStorage.getItem('pendingWarSubmit');
        if (!raw) return null;
        const pending = JSON.parse(raw);
        return pending && pending.orderNo === orderNo ? pending : null;
      } catch (e) {
        return null;
      }
    },
    clearPendingSubmit() {
      localStorage.removeItem('pendingWarSubmit');
    },
    onFinish({selectedOptions}) {
      let selectedOption = selectedOptions[selectedOptions.length - 1];
      if (selectedOption.disabled) {
        Toast("此地区暂不支持修改");
        return;
      }
      this.fieldValue = selectedOptions.map((option) => option.short_name).join('/');
      this.show = false;
      this.location = selectedOption.lng + ',' + selectedOption.lat;
      this.cascaderValue = selectedOption.id;
    },
    onChange({selectedOptions, tabIndex}) {
      const selectedOption = selectedOptions[selectedOptions.length - 1];
      if (!selectedOption) {
        return;
      }
      if (selectedOption.disabled) {
        Toast("此地区暂不支持修改");
        return false;
      }
      // 根据当前选择的层级，按需异步加载下一级数据
      if (selectedOption.level === 1) {
        // 选中了省，加载城市列表
        this.loadCities(selectedOption);
      } else if (selectedOption.level === 2) {
        // 选中了市，加载区县列表
        this.loadCounties(selectedOption);
      }
    },
    backStep(step) {
      --this.stepNum;
      this.submitButtonStatus = false
      if (step === 1) {
        this.fieldValue = '';
        this.cascaderValue = '';
        this.location = '';
      }
    },
    onSearch(val) {
      if (!val || val.trim() === '' || this.gameId === null) {
        this.searchResult = [];
        this.showCascaderList = true;
        return;
      }
      // 使用后端搜索接口，仅搜索第三级区县数据
      this.$axios.get('/api/game/war/district/list', {
        params: { keyword: val, gameId: this.gameId }
      }).then((response) => {
        if (response.data && response.data.code === '0000') {
          const list = response.data.data || [];
          this.searchResult = list.map(item => {
            const parts = [item.province, item.city, item.county].filter(Boolean);
            return {
              id: item.id,
              // 用空格展示完整名称：省 市 区县
              displayFullName: parts.join(' '),
              // 用于后续提交
              level_path: parts.join('/'),
              lng: item.areaLng,
              lat: item.areaLat,
              level: 3,
              parentId: item.parentId,
              disabled: false
            };
          });
          this.showCascaderList = false;
        } else {
          Toast(response.data.desc || '搜索地区失败');
        }
      }).catch(() => {
        Toast('搜索地区失败');
      });
    },
    onCancel() {
      this.showCascaderList = true
    },
    onSearchInput(key) {
      if (!key || key === '') {
        this.showCascaderList = true
        this.searchResult = []
      }
    },
    clickResultItem(item) {
      if (item.disabled) {
        Toast("此地区暂不支持修改");
        return;
      }
      // 搜索选择后，同步更新级联组件的选中值和选中路径
      this.updateCascaderForSearchSelection(item);
      this.cascaderSelectedId = item.id;

      this.show = false;
      this.fieldValue = item.level_path
      this.cascaderValue = item.id
      this.location = item.lng + ',' + item.lat;
      this.searchResult = []
      this.showCascaderList = true
      this.searchKey = ''
    },
    backLastPage() {
      window.history.back()
    },
    goToHelpPage() {
      window.location.href = 'https://yxsaoma.com/help?type=war'
    },
    showUseGuide() {
      ImagePreview({
        images: [
          '//p1.meituan.net/csc/9d0d31b2e6cf77438d8869e6640797d7262092.png',
          '//p0.meituan.net/csc/1e5e981fadb6db48aaab97212f75d296169435.png',
          '//p1.meituan.net/csc/1b2611a9bb3c0baf8f563907cda8d95f172384.png',
          '//p0.meituan.net/csc/83e684191bde746d154a28befe866bcb149040.png',
        ],
        showIndicators: true,
        closeable: true
      });
    },
    payTypeIcon(payType) {
      return payType.icon || PAY_TYPE_ICONS[payType.alias] || '';
    },
    loadPayTypes() {
      this.$axios.get('/api/app/svip/paytypes').then((response) => {
        const list = ('0000' === response.data.code && Array.isArray(response.data.data)) ? response.data.data : [];
        this.payTypes = list;
        this.resetPayCode();
      }).catch(() => {
        this.payTypes = [];
        this.selectedPayCode = '';
      });
    },
    resetPayCode() {
      // 默认选中后台标记 checked 的支付方式,否则取第一项
      const checked = this.payTypes.find(p => p.checked === 1) || this.payTypes[0];
      this.selectedPayCode = checked ? checked.code : '';
    },
    onPay() {
      if (!this.selectedPayCode) {
        Toast('请选择支付方式');
        return;
      }
      this.submitOrderButtonLoading = true;
      Toast('正在提交,请稍后');
      window.setTimeout(() => {
        this.$axios.post('/api/app/order', {
          goodsId: this.goodsId,
          payCode: this.selectedPayCode,
          count: 1,
          categoryId: 2
        }).then((response) => {
          if ('0000' === response.data.code) {
            this.saveOrderNo(response.data.data.orderNo);
            // 保存已选系统/战区,支付完成回跳后自动提交修改
            this.savePendingSubmit(response.data.data.orderNo);
            
            this.showPay = false;
            this.submitOrderButtonLoading = false;
            window.setTimeout(() => {
              location.href = '/api/app/order/pay/' + response.data.data.orderNo;
            }, 200);
          } else {
            Toast(response.data.desc);
            this.submitOrderButtonLoading = false;
          }
        });
      }, 1000);
    },
    onloadGoodsInfo() {
      // 按当前游戏取对应的改战区商品,未配置商品的游戏不可购买
      if (this.gameId === null) {
        this.goodsAvailable = false;
        return;
      }
      this.$axios.get('/api/game/war/goods', {
        params: { gameId: this.gameId }
      }).then((response) => {
        if ('0000' === response.data.code && response.data.data) {
          let goods = response.data.data;
          this.goodsId = goods.id;
          this.goodsPrice = goods.price * 100;
          this.goodsAvailable = true;
        } else {
          this.goodsAvailable = false;
        }
      }).catch(() => {
        this.goodsAvailable = false;
      });
    },
    saveOrderNo(orderNo) {
      if (!window.orderNo || window.orderNo === '') {
        //写入本机订单缓存(含历史列表),订单查询页据此展示"最近订单"
        addOrder(orderNo);
      }
    },
    extractOrderNoFromPath() {
      let orderNoToLoad = null;
      // 优先使用路由参数
      if (this.orderNo) {
        orderNoToLoad = this.orderNo;
      } else {
        // 如果没有路由参数，尝试从URL路径中提取
        const pathParts = window.location.pathname.split('/');
        if (pathParts.length >= 3 && pathParts[1] === 'warzone') {
          const pathOrderNo = pathParts[2];
          if (pathOrderNo && pathOrderNo.length > 0) {
            orderNoToLoad = pathOrderNo;
          }
        }
      }

      if (orderNoToLoad) {
        console.log('Order number detected, starting load:', orderNoToLoad);
        this.isLoading = true;
        this.showOrderNotFoundEmpty = false; // 初始隐藏空状态，等待加载结果
        // 设置全局订单号变量
        window.orderNo = orderNoToLoad;
        // 设置当前订单号
        this.currentOrderNo = orderNoToLoad;
        // 设置为查看历史模式 - 如有需要可在后续根据业务状态开启
        // this.isViewingHistory = true;
        this.loadOrderInfo(orderNoToLoad);
      } else {
        // 如果没有检测到订单号，则不是加载特定订单的场景
        this.isLoading = false; 
        this.isViewingHistory = false; // 确保不是历史查看模式
      }
    },
    loadOrderInfo(orderNo) {
      this.showOrderNotFoundEmpty = false; 
      // 只用战区订单接口检查订单是否有效（是否存在、是否已支付）
      this.$axios.get(`/api/game/war/order/${orderNo}`).then((response) => {
        if ('0000' === response.data.code) {
          const warOrder = response.data.data || {};
          const payStatus = warOrder.status; // 0-未支付 1-已支付 2-已退款
          // 仅当战区订单已支付时，认为当前 warzone 页面有效；否则展示空状态
          if (payStatus === 1) {
            // 订单有效，设置为查看历史模式，显示订单号
            this.isViewingHistory = true;
            // 订单自带游戏类型，按订单游戏应用配置
            if (warOrder.gameId !== undefined && warOrder.gameId !== null) {
              this.applyGame(findGame(this.games, warOrder.gameId));
            }
            // 支付前已选好战区(bindStatus=-1未绑定): 恢复选择并自动提交修改
            const pending = this.getPendingSubmit(orderNo);
            if (pending && warOrder.bindStatus === -1) {
              this.isViewingHistory = false;
              this.gameOs = pending.gameArea;
              this.selectedOSArea = pending.selectedOSArea;
              this.fieldValue = pending.levelPath;
              this.location = pending.location;
              this.cascaderValue = pending.addrId;
              this.stepNum = 3;
              this.doSubmitOrder(orderNo, pending);
            } else if (pending) {
              // 已绑定说明修改已提交过,清掉残留
              this.clearPendingSubmit();
            }
          } else {
            this.showOrderNotFoundEmpty = true;
          }
        } else {
          Toast(response.data.desc || '加载订单信息失败');
          this.showOrderNotFoundEmpty = true;
        }
        this.isLoading = false;
      }).catch(() => {
        Toast('加载订单信息失败');
        this.showOrderNotFoundEmpty = true;
        this.isLoading = false;
      });
    },
    checkLastOrder() {
      this.extractOrderNoFromPath();
      
      if (!window.orderNo || window.orderNo === '') {
        const urlParams = new URLSearchParams(window.location.search);
        const fromHistory = urlParams.get('from') === 'history';
        
        if(fromHistory || (window.orderNo && window.orderNo !== '')) {
          this.isViewingHistory = true;
          this.currentOrderNo = window.orderNo || localStorage.getItem('lastWarOrderNo') || '';
        }
        
        const lastOrderNo = localStorage.getItem('lastWarOrderNo');
        if (lastOrderNo && (!window.orderNo || window.orderNo === '')) {
          // 使用战区订单接口检查最近订单是否有效（是否存在、是否已支付）
          this.$axios.get(`/api/game/war/order/${lastOrderNo}`).then((response) => {
            if ('0000' === response.data.code) {
              const warOrder = response.data.data || {};
              const payStatus = warOrder.status; // 0-未支付 1-已支付 2-已退款
              // 仅在战区订单已支付时，保留最近订单提示能力
              if (payStatus === 1) {
                //最近订单弹窗按游戏隔离:进入某游戏页面时,其他游戏的订单不弹提示(订单本身有效,不清缓存)
                if (!fromHistory && this.game && warOrder.gameId !== undefined
                    && warOrder.gameId !== this.game.gameId) {
                  return;
                }
                if (fromHistory) {
                  this.currentOrderNo = lastOrderNo;
                  return;
                }
                
                Dialog.confirm({
                  title: '订单提示',
                  message: '您有一个最近的订单记录，是否需要查看？', 
                  confirmButtonText: '查看订单',
                  cancelButtonText: '取消',
                  confirmButtonColor: '#465CFF',
                  className: 'custom-dialog',
                  messageAlign: 'center',
                  width: '320px',
                  theme: 'round-button',
                  closeOnClickOverlay: true
                })
                .then(() => {
                  window.location.href = '/warzone/' + lastOrderNo + '?from=history';
                })
                .catch(() => {
                  // 点击取消时什么都不做
                });
              } else {
                //非已支付状态,该订单已失效,从本机缓存(含历史列表)中移除
                removeOrder(lastOrderNo);
              }
            }
          });
        }
      }
    },
    resetState() {
      this.stepNum = 1;
      this.gameOs = '3';
      this.selectedOSArea = '';
      this.show = false;
      this.showCascaderList = true;
      this.fieldValue = '';
      this.location = '';
      this.cascaderValue = '';
      this.searchResult = [];
      this.searchKey = '';
      this.submitButtonStatus = false;
      this.submitButtonText = '';
      this.submitButtonLoading = false;
      this.showPay = false;
      this.resetPayCode();
      this.submitOrderButtonLoading = false;
      this.isViewingHistory = false;
      this.currentOrderNo = '';
      this.showOrderNotFoundEmpty = false;
      this.isLoading = false;
      window.orderNo = '';
    }
  },
  created() {
    console.log('WarOrder created, props orderNo:', this.orderNo);
    console.log('Route params:', this.$route.params);

    // 订单号从 URL 读取(路由参数或 ?orderNo=), 不再依赖后端 Thymeleaf 注入 window.orderNo
    if (!window.orderNo) {
      window.orderNo = this.orderNo || this.$route.params.orderNo || this.$route.query.orderNo || '';
    }

    this.onloadGoodsInfo();
    this.loadPayTypes();
    // 先加载游戏配置,再决定游戏上下文:
    // 1. 带订单号: 由订单详情的 gameId 决定(loadOrderInfo内applyGame)
    // 2. 无订单号但带 ?game= 参数: 按参数选择
    // 3. 两者都没有: 跳转游戏选择页
    loadGames().then((games) => {
      this.games = games;
      const queryGame = findGame(games, this.$route.query.game);
      const hasOrderNo = !!(this.orderNo || (window.location.pathname.split('/')[1] === 'warzone'
          && window.location.pathname.split('/')[2]));
      if (queryGame) {
        this.applyGame(queryGame);
      } else if (!hasOrderNo) {
        this.$router.replace('/warzone/games');
        return;
      }
      this.checkLastOrder();
      if (!this.game) {
        // 订单游戏尚未确定时先按王者荣耀预载省份,订单详情返回后如游戏不同会重载
        this.loadProvinces();
      }
    }).catch(() => {
      // 配置加载失败时退回单游戏(王者)行为,保证老流程可用
      this.checkLastOrder();
      this.loadProvinces();
    });
  },
  mounted() {
    console.log('WarOrder mounted, props orderNo:', this.orderNo);
    console.log('Current orderNo:', this.currentOrderNo);
    console.log('Is viewing history:', this.isViewingHistory);
    
    if (this.isViewingHistory && this.currentOrderNo) {
      this.submitButtonStatus = true;
      this.submitButtonText = '订单已提交';
    }
  }
}
</script>

<style>
.option_name.optdisabled {
  color: #999;
}

.game-title-icon {
  width: 22px;
  height: 22px;
  border-radius: 5px;
  vertical-align: -4px;
  margin-right: 4px;
}

.option_name.optdisabled ~ .van-icon {
  opacity: 0;
}

.fui-page__hd {
  width: 100%;
  box-sizing: border-box;
  padding: 1.625rem 1rem;
}

.fui-page__title {
  text-align: left;
  font-size: 1.025rem;
  font-weight: 600;
}

.fui-page__desc {
  margin-top: 0.25rem;
  color: #b2b2b2;
  text-align: left;
  font-size: .875rem;
  font-weight: 400;
  word-break: break-all;
}

.fui-section__title {
  margin-left: 1rem;
}

.fui-section__title {
  font-size: 1rem;
  line-height: 1rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
  padding-left: 0.5rem;
  position: relative;
  box-sizing: border-box;
}

.fui-section__title:after {
  content: "";
  position: absolute;
  width: 4px;
  height: 100%;
  background: red;
  border-radius: 2px;
  left: 0;
  top: 0;
}

.nextBtn {
  padding: 1.5rem;
}

.van-button--info {
  border-radius: 5px;
}

.van-button-back {
  color: rgb(70, 92, 255) !important;
  font-weight: bold !important;
}

.van-submit-bar {
  position: relative !important;
}

.pay {
  padding: 3.666667vw;
  font-size: 3.733333vw;
  line-height: 5.333333vw;
  color: #262628;
  padding-top: 0 !important;
}

.pay .title {
  margin-bottom: 2.666667vw;
  font-weight: 600;
}

.pay .pay-wrap {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  align-content: flex-start;
  row-gap: 2.666667vw;
}

.pay .pay-empty {
  width: 100%;
  text-align: center;
  color: #969799;
  padding: 4vw 0;
}

.pay .pay-type sup {
  color: #ff4461;
  font-size: 2.4vw;
  margin-left: 0.8vw;
}

.pay .pay-type.active {
  border-color: #ff4461;
  background-color: #ffecef;
}

.pay .pay-type {
  width: 44vw;
  height: 9.6vw;
  border-radius: 1.866667vw;
  border: 1px solid #e5e5e5;
  transition: width .5s;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: nowrap;
  align-content: flex-start;
  color: #262628;
  font-size: 3.2vw;
  line-height: 9.6vw;
  text-align: center;
  font-weight: 400;
  position: relative;
}

.pay .pay-type img {
  height: 6.133333vw;
  margin-right: 2.666667vw;
}

.pay .pay-type .check {
  margin-right: 0;
  position: absolute;
  right: 0;
  bottom: 0;
  z-index: 20;
  height: 5.333333vw;
  display: none;
}

.pay .pay-type.active .check {
  display: block;
}

.custom-dialog .van-dialog__footer {
  padding: 8px 16px 16px;
}

.custom-dialog .van-dialog__confirm,
.custom-dialog .van-dialog__cancel {
  flex: 1;
  margin: 0 8px;
  height: 40px;
  font-size: 16px;
  border-radius: 5px;
}

.custom-dialog .van-dialog__confirm {
  color: white;
  background: #465CFF;
  border-color: #465CFF;
}

.custom-dialog .van-dialog__cancel {
  color: #465CFF;
  background: white;
  border: 1px solid #465CFF;
}

.custom-dialog .van-dialog__header {
  padding: 20px 0 8px;
  font-weight: 600;
  font-size: 18px;
}

.custom-dialog .van-dialog__message {
  padding: 8px 16px 20px;
}

.van-cascader__option--disabled {
  color: #999;
  cursor: not-allowed;
}

.van-cascader__option--disabled .van-cell__right-icon {
  opacity: 0;
}

.history {
  color: #ff4461;
}

.history-tag {
  display: inline-block;
  font-size: 0.75rem;
  padding: 2px 8px;
  background-color: #465CFF;
  color: white;
  border-radius: 4px;
  margin-right: 8px;
  font-weight: normal;
  vertical-align: middle;
  letter-spacing: 0.5px;
}

.fui-page__title {
  position: relative;
}

.fui-page__title .history-tag + span {
  vertical-align: middle;
}
</style>
